const generateGlassMarkup = () => {
  return `
    <style>
      :host {
        display: none;
      }

      :host(.glass-is-added) {
        display: block;
      }

      .bundle-glass .placeholder-image {
        width: 13vw;
        height: auto;
      }

      @media screen and (min-width: 767px) {
        .bundle-glass .placeholder-image {
          width: 10vw;
        }
      }

      @media screen and (min-width: 991px) {
        .bundle-glass .placeholder-image {
          width: 8vw;
        }
      }
  
    </style>
    <div class="bundle-glass" part="glass-image">
      <img class="placeholder-image" src="https://cdn.shopify.com/s/files/1/0492/9857/1425/files/bundle-glass.png?v=1694654114">
    </div>
  `;
};

export class BundleGlass extends HTMLElement {
  private readonly root: HTMLDivElement;
  private readonly glassImage: HTMLImageElement;

  constructor() {
    super();

    const template = document.createElement('template');
    template.innerHTML = generateGlassMarkup();

    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));

    this.root = shadowRoot.querySelector('.bundle-glass')!;
    this.glassImage = shadowRoot.querySelector('.glass-image')!;
  }

  public setImageSrc(imageSrc: string | null) {
    if (this.glassImage) {
      this.glassImage.src = imageSrc ?? '';
    }
  }

  public setGlassIsAdded(isAdded:boolean) {
    this.classList[isAdded ? 'add' : 'remove']('glass-is-added');
  }

  public setHasGlass(hasGlass:boolean) {
    this.root.classList[hasGlass ? 'add' : 'remove']('has-glass')
  }
}

if (!customElements.get('bundle-glass')) {
  customElements.define('bundle-glass', BundleGlass);
}
